// Utility functions for handling file uploads
export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
};

export const validateAudioFile = (file) => {
  const validTypes = ['audio/mpeg', 'audio/mp3', 'audio/wav', 'audio/x-m4a', 'audio/mp4', 'audio/flac', 'audio/ogg', 'audio/aac'];
  const validExtensions = ['.mp3', '.wav', '.m4a', '.flac', '.ogg', '.aac'];
  const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
  
  return validTypes.includes(file.type) || validExtensions.includes(fileExtension);
};

export const createFormData = (data, files = [], previewFiles = []) => {
  const formData = new FormData();
  
  // Add regular form fields
  Object.keys(data).forEach(key => {
    if (key !== 'files' && key !== 'previewFiles') {
      if (data[key] !== null && data[key] !== undefined) {
        if (typeof data[key] === 'object' && !Array.isArray(data[key])) {
          formData.append(key, JSON.stringify(data[key]));
        } else if (Array.isArray(data[key])) {
          formData.append(key, JSON.stringify(data[key]));
        } else {
          formData.append(key, data[key]);
        }
      }
    }
  });
  
  // Add files
  files.forEach((file, index) => {
    formData.append('files', file);
    if (file.trackNumber !== undefined) {
      formData.append(`trackNumber_${file.name}`, file.trackNumber || index);
    }
  });
  
  // Add preview files
  previewFiles.forEach((file, index) => {
    formData.append('previews', file);
    if (file.trackNumber !== undefined) {
      formData.append(`trackNumber_${file.name}`, file.trackNumber || index);
    }
  });
  
  return formData;
};

